import { useEffect, useRef, useState } from 'react';

const IFRAME_LOAD_TIMEOUT = 15000;

export const useDocumentPreviewRendering = () => {
  const loadedRef = useRef(false);
  const [isPending, setIsPending] = useState(true);
  const [isError, setIsError] = useState<boolean>(false);

  const onLoad = () => {
    setIsPending(false);
    loadedRef.current = true;
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!loadedRef.current) {
        setIsError(true);
        setIsPending(false);
      }
    }, IFRAME_LOAD_TIMEOUT);

    return () => clearTimeout(timer);
  }, []);

  return {
    isPending,
    onLoad,
    isError,
  };
};
